import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import {
  HireContext,
  HireContextValue,
  HireStep,
  useHireSteps,
} from "@/pages/employees/hire/hire-context";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { DotSeparator, Stack, Text } from "@skailer-com/uikit";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface HireTitleSlotProps {
  step: HireStep;
  employee?: ApiEmployee;
}

export const HireTitleSlot = ({ step, employee }: HireTitleSlotProps) => {
  const { t } = useTranslation();
  const { renderEmployeeName } = useFormatter();
  const hireSteps = useHireSteps();
  const stepIndex = hireSteps.indexOf(step);

  return (
    <DotSeparator className={"inline-flex"}>
      <Text className={"font-semibold"}>{t("core:new_employee")}</Text>
      {stepIndex > 0 && employee && (
        <Stack gap={"sm"} direction={"horizontal"} items={"center"}>
          <EmployeeAvatar size={"sm"} employee={employee} />
          <Text className={"font-semibold"}>{renderEmployeeName(employee)}</Text>
        </Stack>
      )}
      {hireSteps.length > 1 && (
        <Text>
          {t("core:step_of", {
            currentStep: stepIndex + 1,
            countSteps: hireSteps.length,
          })}
        </Text>
      )}
    </DotSeparator>
  );
};

interface HireProviderProps {
  children: ReactNode;
  value: HireContextValue;
}

export const HireProvider = ({ children, value }: HireProviderProps) => {
  return <HireContext.Provider value={value}>{children}</HireContext.Provider>;
};
